import React, { useEffect, useRef, useState } from "react";
import { Button, Alert } from "react-bootstrap";
import { BrowserQRCodeReader } from "@zxing/browser";

const QRScanner = ({ show, onClose, onScan }) => {
  const videoRef = useRef(null);
  const readerRef = useRef(null);
  const isProcessingRef = useRef(false); // Use ref instead of state for immediate check
  const [error, setError] = useState(null);
const [hasPermission, setHasPermission] = useState(null);


useEffect(() => {
  const checkPermission = async () => {
    try {
      const permissionStatus = await navigator.permissions.query({
        name: "camera",
      });
      setHasPermission(permissionStatus.state === "granted");
      permissionStatus.onchange = () => {
        setHasPermission(permissionStatus.state === "granted");
      };
    } catch (err) {
      console.warn("[QRScanner] Permission API not supported", err);
      setHasPermission(null);
    }
  };
  
  if (show) checkPermission();
}, [show]);

  useEffect(() => {
    if (show) {
      isProcessingRef.current = false; // Reset processing flag when scanner opens
      startScanner();
    } else {
      stopScanner();
    }

    return () => stopScanner(); // cleanup
  }, [show]);

  // const startScanner = async () => {
  //   try {
  //     console.log("[QRScanner] Starting scanner...");
  //     readerRef.current = new BrowserQRCodeReader();

  //     const devices = await BrowserQRCodeReader.listVideoInputDevices();
  //     console.log("[QRScanner] Available devices:", devices);

  //     const backCamera =
  //       devices.find((d) => d.label.toLowerCase().includes("back")) || devices[0];

  //     if (!backCamera) {
  //       alert("No camera found on this device.");
  //       onClose();
  //       return;
  //     }

  //     console.log("[QRScanner] Using device:", backCamera);

  //     readerRef.current.decodeFromVideoDevice(
  //       backCamera.deviceId,
  //       videoRef.current,
  //       (result, error) => {
  //         // Check if we're already processing a QR code
  //         if (result && !isProcessingRef.current) {
  //           console.log("[QRScanner] QR Code detected:", result.getText());
            
  //           // Immediately set the flag to prevent multiple calls
  //           isProcessingRef.current = true;
            
  //           // Stop scanner first
  //           stopScanner();
            
  //           // Then call the callback
  //           onScan(result.getText());
            
  //           // Close the scanner
  //           onClose();
  //         }

  //         // Ignore normal decode errors (partial, blurry QR)
  //         if (
  //           error &&
  //           !["NotFoundException", "ChecksumException", "FormatException"].includes(
  //             error.name
  //           )
  //         ) {
  //           console.error("[QRScanner] Decode error:", error);
  //         }
  //       }
  //     );
  //   } catch (err) {
  //     console.error("[QRScanner] Camera access error:", err);
  //     alert("Camera access error: " + err);
  //     onClose();
  //   }
  // };



  const startScanner = async () => {
  try {
    console.log("[QRScanner] Starting scanner...");
    setError(null); // Clear errors
    
    // Add this check
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      throw new Error("Browser doesn't support camera access");
    }

    readerRef.current = new BrowserQRCodeReader();

    // Add this camera access test
    const testStream = await navigator.mediaDevices.getUserMedia({
      video: {
        facingMode: "environment",
        width: { ideal: 1280 },
        height: { ideal: 720 }
      }
    });
    testStream.getTracks().forEach(track => track.stop());

    // ... rest of your existing code


     readerRef.current = new BrowserQRCodeReader();

      const devices = await BrowserQRCodeReader.listVideoInputDevices();
      console.log("[QRScanner] Available devices:", devices);

      const backCamera =
        devices.find((d) => d.label.toLowerCase().includes("back")) || devices[0];

      if (!backCamera) {
        alert("No camera found on this device.");
        onClose();
        return;
      }

      console.log("[QRScanner] Using device:", backCamera);

      readerRef.current.decodeFromVideoDevice(
        backCamera.deviceId,
        videoRef.current,
        (result, error) => {
          // Check if we're already processing a QR code
          if (result && !isProcessingRef.current) {
            console.log("[QRScanner] QR Code detected:", result.getText());
            
            // Immediately set the flag to prevent multiple calls
            isProcessingRef.current = true;
            
            // Stop scanner first
            stopScanner();
            
            // Then call the callback
            onScan(result.getText());
            
            // Close the scanner
            onClose();
          }

          // Ignore normal decode errors (partial, blurry QR)
          if (
            error &&
            !["NotFoundException", "ChecksumException", "FormatException"].includes(
              error.name
            )
          ) {
            console.error("[QRScanner] Decode error:", error);
          }
        }
      );

  } catch (err) {
    console.error("[QRScanner] Camera access error:", err);
    
    // Add these specific error messages
    if (err.name === "NotAllowedError" || err.message.includes("permission")) {
      setError("Camera permission denied. Please allow camera access in your browser settings.");
    } else if (err.name === "NotFoundError") {
      setError("No camera found on this device.");
    } else {
      setError("Camera access error: " + err.message);
    }
  }
};
  const stopScanner = () => {
    // Stop the ZXing reader
    if (readerRef.current) {
      try {
        readerRef.current.reset?.(); // optional chaining to avoid errors
      } catch (err) {
        console.warn("[QRScanner] Reset failed", err);
      }
      readerRef.current = null;
    }

    // Explicitly stop all video tracks (camera)
    if (videoRef.current && videoRef.current.srcObject) {
      const stream = videoRef.current.srcObject;
      const tracks = stream.getTracks();
      tracks.forEach(track => {
        track.stop();
        console.log("[QRScanner] Camera track stopped:", track.label);
      });
      videoRef.current.srcObject = null;
    }
    
    console.log("[QRScanner] Scanner and camera stopped.");
  };

  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0,0,0,0.85)",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 2000,
        padding: "10px",
        transition: "opacity 0.3s ease",
      }}
    >


      {
        !error &&  <>
      <video
        ref={videoRef}
        style={{
          width: "100%",
          maxWidth: "500px",
          borderRadius: "10px",
          background: "#000",
        }}
        muted
        autoPlay
        playsInline
      />
      <Button
        onClick={() => {
          stopScanner();
          onClose();
        }}
        variant="secondary"
        style={{ marginTop: "10px" }}
      >
        Close
      </Button>
      </>
      }
     

        {error && (
      <Alert 
        variant="danger" 
        style={{ 
          position: "absolute", 
          top: "20px", 
          maxWidth: "90%",
          zIndex: 2001 
        }}
      >
        {error}
        <br />
        <Button 
          variant="light" 
          size="sm" 
          onClick={() => window.location.reload()}
          style={{ marginTop: "5px" }}
        >
          Reload and Try Again
        </Button>
      </Alert>
    )}
    </div>
  );
};

export default QRScanner;